import type { SagaIterator } from 'redux-saga';
import { call, delay, put } from 'redux-saga/effects';
import type { ActionCreator } from 'typesafe-actions';
import { showMessage } from '../messages/actions';
import { queryImportStatus } from './api';
import { IMPORT_STATUS } from './types';

export type handleSuccessPayload = {
  projectId: string;
  newProject: boolean;
};

export function* reportImportStatus(
  importId: string,
  handleStatusUpdate: ActionCreator,
  handleSuccess: ActionCreator,
  newProject: boolean
): SagaIterator {
  const fetchStatusRetries = 20;
  const fetchStatusRetryWait = 500;
  let fetchStatusAttempts = 0;

  while (fetchStatusAttempts < fetchStatusRetries) {
    const { importStatus } = yield call(queryImportStatus, { importId });
    if (importStatus === null) {
      fetchStatusAttempts++;
    } else {
      if (importStatus.status === 'running') {
        yield put(handleStatusUpdate(IMPORT_STATUS.RUNNING));
      }

      if (importStatus.status === 'completed') {
        yield put(handleSuccess({ projectId: importStatus.projectId, newProject }));
        yield put(handleStatusUpdate(IMPORT_STATUS.NOT_STARTED));
        return;
      }

      if (importStatus.status === 'error') {
        yield put(showMessage('error', importStatus.message));
        yield put(handleStatusUpdate(IMPORT_STATUS.NOT_STARTED));
        return;
      }
    }

    yield delay(fetchStatusRetryWait);
  }

  yield put(showMessage('error', 'Could not get import status.'));
  yield put(handleStatusUpdate(IMPORT_STATUS.NOT_STARTED));
}
